import * as ReactRouter from 'react-router-dom';
import { parseQuery } from 'utils/url/parse-query';

export function useSearchQuery() {
  const location = ReactRouter.useLocation();

  return parseQuery(location.search) ?? {};
}
